import React from "react";
// nodejs library that concatenates classes
import classNames from "classnames";
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
import renderHTML from "react-render-html";
// @material-ui/icons
import { Button, NoSsr } from "@material-ui/core";
import ProductSection from "./Sections/HtmlSection.js";

// core components
import GridContainer from "components/uikit/Grid/GridContainer.js";
import GridItem from "components/uikit/Grid/GridItem.js";
// import Button from "components/uikit/CustomButtons/Button.js";
import Parallax from "components/uikit/Parallax/Parallax.js";
import styles from "assets/jss/material-kit-react/views/mainPage.js";
// Sections for this page
import { API, graphqlOperation } from "aws-amplify";
import { getShowBoothItem } from "graphql/queries";
import PhotoGrallery from "components/atoms/PhotoGralleryViewer";
import styled from "styled-components";
import SimpleYoutube from "components/atoms/SimpleYoutube";
import ThetaViewer from "components/atoms/ThetaViewer";
import BoothUserInfo from "components/molecures/BoothUserInfo";
import Breadcrumbs from "components/molecures/Breadcrumbs";

const useStyles = makeStyles(styles);

const LogoImg = styled.img`
  width: 100%;
`;

const Logos = styled.div`
  width: 100%;
  padding: 1rem;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const LogoItem = styled.div`
  width: 100%;
  max-width: 240px;
  flex: auto;
`;

const SectionTitle = styled.h4`
  font-size: 24px;
  color: #333;
`;

const ViewerWrapper = styled.div`
  text-align: center;
  div {
    display: inline-block;
  }
`;

export default function Main(props) {
  const classes = useStyles();
  const { show, booth, boothItem, info } = props;
  const [data, setData] = React.useState();
  const [photos, setPhotos] = React.useState([]);

  React.useEffect(() => {
    async function f() {
      const res = await API.graphql(
        // @ts-ignore
        graphqlOperation(getShowBoothItem, {
          id: boothItem.id,
        })
      );
      // @ts-ignore
      setData(res.data.getShowBoothItem);
      if (res.data.getShowBoothItem.photoGallery) {
        const phots = res.data.getShowBoothItem.photoGallery.phots.items;
        const images = phots
          .sort((a, b) => a.albumOrder - b.albumOrder)
          .map((item: any) => {
            return {
              title: item.phot.alternate,
              src: item.phot.url,
              width: 5,
              height: 3,
            };
          });
        setPhotos(images);
      }
    }
    f();
  }, [boothItem.id]);

  return (
    <div>
      {show && data && (
        <>
          <Parallax
            filter
            style={{ height: "60vh" }}
            image={data.mainImage ? data.mainImage.url : null}
          >
            <div className={classes.container}>
              <GridContainer>
                <GridItem xs={12} sm={12} md={8}>
                  <h2 className={classes.title}>{renderHTML(data.title)}</h2>
                  {/* {data.discription && (
                    <div className={classes.discription}>
                      {renderHTML(data.discription)}
                    </div>
                  )} */}
                </GridItem>
              </GridContainer>
            </div>
          </Parallax>
          <div className={classNames(classes.main, classes.mainRaised)}>
            <div className={classes.container}>
              <Breadcrumbs show={show} booth={booth} boothItem={boothItem} />

              {data && (
                <>
                  {data.logo && (
                    <Logos>
                      <LogoItem>
                        <LogoImg
                          src={data.logo.url}
                          alt={data.logo.alternate}
                        />
                      </LogoItem>
                    </Logos>
                  )}
                  {data.description && (
                    <ProductSection data={data.description} />
                  )}

                  {data.view360 && (
                    <>
                      <SectionTitle>360 view</SectionTitle>
                      <ViewerWrapper>
                        <ThetaViewer id={data.view360} />
                      </ViewerWrapper>
                    </>
                  )}

                  {photos && photos.length > 0 && (
                    <>
                      <SectionTitle>Photos</SectionTitle>
                      <PhotoGrallery photos={photos} />
                    </>
                  )}
                  {data.productUrl && (
                    <Button
                      color="primary"
                      size="large"
                      href={data.productUrl}
                      target="_blank"
                    >
                      詳細はこちら
                    </Button>
                  )}

                  {data.movie && (
                    <>
                      <SectionTitle>Movie</SectionTitle>
                      <SimpleYoutube id={data.movie} />
                    </>
                  )}

                  {data.section && <ProductSection data={data.section} />}
                  {info && (
                    <>
                      <SectionTitle>お問い合わせ</SectionTitle>
                      <BoothUserInfo data={info} />
                    </>
                  )}
                </>
              )}
              {/* <TeamSection />
          <WorkSection /> */}
            </div>
          </div>
        </>
      )}
    </div>
  );
}
